import React, { useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteCompany } from "../../store/companies/actions";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { firestore } from "../../firebase";
import { textoLicencia } from "../../helpers/fechasLicencia";
import { doc, getFirestore, collection, query, where, getDocs, deleteDoc } from 'firebase/firestore';


import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Button,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";


const CompanyOptions = (props) => {
    document.title = "Estacionamientos | TicketControl - Monitor";
    const dispatch = useDispatch();
    const  [companies, setCompanies] = useState([]);
    const [modal, setmodal] = useState(false);
    const [currentCompany, setCurrentCompany] = useState({});
    const usersRef = collection(firestore, 'users');
    const [userEmail, setUserEmail] = useState(null)
    const licences = useSelector((state) => state.companies.licences) || {}

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setUserEmail(obj.email);
            } else if (
                process.env.REACT_APP_DEFAULTAUTH === "fake" ||
                process.env.REACT_APP_DEFAULTAUTH === "jwt"
            ) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setUserEmail(obj.email);
            }
        }
    }, []);


    useEffect(() => {
        //fetch companies
        setCompanies(props.companies);
    }, [props.companies]);



    const LICENCIAS_URL = process.env.REACT_APP_LICENCIAS_URL || "https://licencias.ticketcontrol.net";

    const buildRenewUrl = (companyId) => {
        const lic = licences[companyId];
        const url = new URL(LICENCIAS_URL + "/comprar-licencia");
        url.searchParams.set("key", companyId);
        if (lic) {
            url.searchParams.set("anpr", lic.anpr ? "1" : "0");
            url.searchParams.set("invoices", lic.invoices ? "1" : "0");
            url.searchParams.set("api", lic.api ? "1" : "0");
            url.searchParams.set("limit", String(lic.limit ?? 0));
        }
        return url.toString();
    };

    const getLicenceInfo = (companyId) => {
        const lic = licences[companyId];
        if (!lic) return { text: "Sin datos", color: "secondary", icon: "help", expired: false };
        if (!lic.untildate) return { text: "Sin licencia", color: "danger", icon: "block", expired: true };

        // Con el criterio único (helpers/fechasLicencia.js): la fecha guardada es el
        // primer día SIN licencia, y al cliente se le dice el último día. Es la misma
        // frase que muestra el aviso de vencimiento.
        const estado = textoLicencia(lic.untildate);
        if (!estado) return { text: "Sin datos", color: "secondary", icon: "help", expired: false };
        if (estado.caso === "vencida") {
            return { text: estado.texto, color: "danger", icon: "error", expired: true };
        } else if (estado.caso === "vigente") {
            return { text: estado.texto, color: "success", icon: "verified", expired: false };
        } else {
            return { text: estado.texto, color: "warning", icon: "warning", expired: false };
        }
    };

    if (!props.companies || props.companies.length == 0) {
        return null
    }

    const deleteCompany_confirm = (company) => {
        setCurrentCompany(company)
        setmodal(true)
    }

    const toggleModal = () => { 
        setmodal(!modal)
    }

    const deleteCompanyRun = () => {
        setmodal(false)
        // dispatch(deleteCompany(currentCompany))
        deleteFromFirestore(currentCompany)
        
    }


    const reloadPage = () => {
        window.location.reload();
    };

    const deleteFromFirestore = async (company) => {
        const db = getFirestore();
        const key = company.id
        const email_for_delete = userEmail;

        // Referencia a la subcolección 'auth' del documento específico en 'users'
        const authCollectionRef = collection(db, 'users', key, 'auth');
       
        // Crea una consulta para encontrar el documento en la subcolección 'auth' donde el campo 'email' coincide con 'email_for_delete'
        const q = query(authCollectionRef, where('email', '==', email_for_delete));

        try {
            // Ejecuta la consulta
            const querySnapshot = await getDocs(q);

            // Si se encuentra el documento, procede a eliminarlo
            querySnapshot.forEach(async (doc) => {
                await deleteDoc(doc.ref);
                console.log('Documento eliminado con éxito:', doc.id);
                reloadPage()
            });

        } catch (error) {
            console.error('Error eliminando el documento:', error);
        }
        


    }




    return (
        <>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="TicketControl" breadcrumbItem="Estacionamientos" />

                    <div className="text-muted mb-3" style={{ fontSize: 13 }}>
                        <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>local_parking</span>
                        Estos son los estacionamientos vinculados a tu cuenta de Monitor. Desde aquí puedes ver su información y desvincularlos si lo necesitas.
                    </div>

                    <Row className="g-3">
                        {[...companies].sort((a, b) => {
                            const la = licences[a.id], lb = licences[b.id];
                            const da = la?.untildate ? new Date(la.untildate) : new Date(0);
                            const db = lb?.untildate ? new Date(lb.untildate) : new Date(0);
                            return da - db;
                        }).map((company) => {
                            const info = getLicenceInfo(company.id);
                            const isCurrent = props.currentCompany?.id === company.id;
                            const displayName = company.name || company.id;

                            return (
                            <Col key={company.id} xs={12} sm={12} md={6} lg={4}>
                            <Card
                                className="shadow-sm mb-0"
                                style={{
                                    borderLeft: isCurrent ? "3px solid var(--bs-success)" : "3px solid var(--bs-primary)",
                                    borderRadius: 8,
                                }}
                            >
                                <CardBody>
                                    <div className="d-flex align-items-center mb-2">
                                        <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 22 }}>local_parking</span>
                                        <h5 className="m-0 text-uppercase" style={{ fontWeight: 600, flex: 1, minWidth: 0 }}>{displayName}</h5>
                                        {isCurrent && (
                                            <Badge color="success" className="ms-2 py-1 px-2" style={{ fontSize: 10, fontWeight: 500 }}>
                                                Actual
                                            </Badge>
                                        )}
                                    </div>
                                    <div className="text-muted mb-1" style={{ fontSize: 13 }}>
                                        <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>key</span>
                                        Key: <code style={{ fontSize: 12 }}>{company.id}</code>
                                    </div>
                                    {(company.address || company.city) && (
                                        <div className="text-muted mb-1" style={{ fontSize: 13 }}>
                                            <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>location_on</span>
                                            {[company.address, company.city].filter(Boolean).join(" - ")}
                                        </div>
                                    )}
                                    <div className="mb-3 mt-2">
                                        <Badge color={info.color} className="py-1 px-2" style={{ fontSize: 12, fontWeight: 500 }}>
                                            <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>{info.icon}</span>
                                            {info.text}
                                        </Badge>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Button
                                            outline
                                            color="danger"
                                            size="sm"
                                            className="flex-grow-1"
                                            style={{ fontSize: 12 }}
                                            onClick={() => deleteCompany_confirm(company)}
                                        >
                                            <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>delete</span>
                                            Eliminar
                                        </Button>
                                        <a
                                            href={buildRenewUrl(company.id)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`btn btn-${info.expired ? "warning" : "primary"} btn-sm flex-grow-1`}
                                            style={{ fontSize: 12 }}
                                        >
                                            <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>
                                                {info.expired ? "autorenew" : "add_circle"}
                                            </span>
                                            {info.expired ? "Renovar" : "Extender"}
                                        </a>
                                    </div>
                                </CardBody>
                            </Card>
                            </Col>
                            );
                        })}
                        </Row>

                        <div className="mt-4 p-3 rounded" style={{ background: "rgba(var(--bs-primary-rgb), 0.08)", fontSize: 13 }}>
                            <div className="mb-2">
                                <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 18, verticalAlign: "middle" }}>lightbulb</span>
                                <strong>¿Sabías que puedes extender tu licencia en cualquier momento?</strong> Los días restantes no se pierden — los nuevos días se suman a los que ya tienes.
                            </div>
                            <div className="text-muted" style={{ fontSize: 12 }}>
                                <span className="material-symbols-rounded me-1" style={{ fontSize: 13, verticalAlign: "middle" }}>info</span>
                                Al eliminar un estacionamiento solo lo desvinculás de tu cuenta en Monitor. Podés volver a incorporarlo desde TicketControl &rarr; Configuración &rarr; Auditoría &rarr; Monitor.
                            </div>
                        </div>

                
                    <Modal isOpen={modal} toggle={toggleModal} centered>
                        <ModalHeader toggle={toggleModal}>
                            Confirmar eliminación
                        </ModalHeader>
                        <ModalBody>
                            <p>
                                ¿Deseas eliminar este estacionamiento de tu cuenta en TicketControl Monitor?
                            </p>
                            <p className="text-muted" style={{ fontSize: 13 }}>
                                Esta acción no es crítica. Puedes volver a incorporarlo desde TicketControl en Configuración &rarr; Auditoría &rarr; Monitor.
                            </p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={deleteCompanyRun}>
                                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>delete</span>
                                Sí, eliminar
                            </Button>
                            <Button color="secondary" onClick={toggleModal}>
                                Cancelar
                            </Button>
                        </ModalFooter>
                    </Modal>


                </Container>
            </div>
        </>
    );
}



const mapStateToProps = (state) => {
    return {
        companies: state.companies.companies,
        currentCompany: state.companies.currentCompany,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CompanyOptions);